import { render, staticRenderFns } from "./CreateProducts.vue?vue&type=template&id=c547f29e&scoped=true&"
import script from "./CreateProducts.vue?vue&type=script&lang=js&"
export * from "./CreateProducts.vue?vue&type=script&lang=js&"
import style0 from "./CreateProducts.vue?vue&type=style&index=0&id=c547f29e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c547f29e",
  null
  
)

export default component.exports